window.droppedFiles = false;
var showFiles       = function(files) {
        var $label = $('#tax-exempt-form').find('.box__input:first > label:first');

        if(files.length === 0) {
            $label.find('.unselected').show();
            $label.find('.selected').hide();
            return;
        }

        $label.find('#box-file-name').text(files[ 0 ].name);
        $label.find('.unselected').hide();
        $label.find('.selected').show();
    };

window.addEventListener('load', function() {
    $('#tax-exempt-form')
        .preventReturnSubmit()
        // box
        .on('drag dragstart dragend dragover dragenter dragleave drop', '.box', function(e) {
            e.preventDefault();
            e.stopPropagation();
        })
        .on('dragover dragenter', '.box', function() {
            $(this).addClass('is-dragover');
        })
        .on('dragleave dragend drop', '.box', function() {
            $(this).removeClass('is-dragover');
        })
        .on('drop', '.box', function(event) {
            droppedFiles = event.originalEvent.dataTransfer.files;

            var $input = $(this).find('[type="file"]:first');
            $input.replaceWith($input.val('').clone(true));

            showFiles(droppedFiles);
        })
        // input
        .on('change', '[type="file"]', function(event) {
            droppedFiles = false;
            showFiles(event.target.files);
        })
        // submit
        .on('submit', function(event) {
            event.preventDefault();

            var $form  = $(this);
            var $btn   = $form.find('[type="submit"]:first');
            var $input = $form.find('[type="file"]:first');

            $form.find('.alert').remove();

            if($input[0].files.length === 0 && (!droppedFiles || droppedFiles.length === 0)) {
                $('#upload-alert').prependAlert('Please complete the form and choose a file to submit.', 'error');
                return;
            }

            $btn.disable().next('.process-notice').show();

            var formData = new FormData(this);

            if(droppedFiles) {
                $.each(droppedFiles, function(i, file) {
                    formData.append($input.attr('name'), file, file.name);
                });
            }

            $.post({
                url: '/pages/tax-exempt',
                data: formData,
                dataType: 'json',
                cache: false,
                contentType: false,
                processData: false
            })
            .fail(function(xhr) {
                var message = errorMessageFromXhr(xhr);

                $('#upload-alert').prependAlert(message, 'error');

                $btn.enable().next('.process-notice').hide();
            })
            .always(function(){
                $btn.enable().next('.process-notice').hide();
            })
            .done(function(data) {
                $('#upload-alert').prependAlert('Your submission was successful.', 'success');

                droppedFiles = false;
                $form.find(':input').val('');
                $form.find(':input').trigger('change');

                $input.replaceWith($input.val('').clone(true));
            });

        })
        // enable submit after load
        .find('[type="submit"]').enable();
});
